import React from 'react';

import { AnalyticsContext } from './AnalyticsContext';
import { type AnalyticsProviderProps } from './types';

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */
// eslint-disable-next-line @repo/internal/react/no-class-components
export default class AnalyticsProvider extends React.Component<AnalyticsProviderProps> {
	state = {
		analytics: this.props.analytics,
	};
	render(): React.JSX.Element {
		return (
			<AnalyticsContext.Provider value={this.state}>
				{this.props.children}
			</AnalyticsContext.Provider>
		);
	}
}
